export default __webpack_public_path__ + "static/media/appstore.15f01eef.svg";